export const getConfig = (titleName, options) => {
    let result = { display: false };
    if (titleName != null) {
        result = options;
        result.display = true;
        result.text = titleName;
    }
    return result;
};
//# sourceMappingURL=TitleLoader.js.map